/** A yes/no answer: `null` means "not answered yet" and is never sent to the backend. */
export type YesNoValue = boolean | null;

/** One row of the harmful-substances table as edited in the form (no id / position). */
export interface SubstanceRow {
    chemical: string;
    dangerClass: string;
    risks: string;
    firstAid: string;
}

export const EMPTY_SUBSTANCE_ROW: SubstanceRow = {
    chemical: '',
    dangerClass: '',
    risks: '',
    firstAid: '',
};
